// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"83dc9e5d","453":"1cfc6aac","934":"7edf9e86"}[chunkId] + ".chunk.js";
};